import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import IconButton from "../Button/IconButton";
import css from "./CopyButton.module.css";

const COPIED_DURATION = 2000;

const CopyButton = React.forwardRef(
  (
    {
      text,
      label = "Copy to clipboard",
      copiedLabel = "Copied!",
      renderIcon,
      renderCopiedIcon,
      className,
      ...rest
    },
    ref,
  ) => {
    const [copied, setCopied] = React.useState(false);
    const timeoutRef = React.useRef(null);

    React.useEffect(
      () => () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
      },
      [],
    );

    const handleClick = () => {
      navigator.clipboard.writeText(text).then(() => {
        setCopied(true);
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(
          () => setCopied(false),
          COPIED_DURATION,
        );
      });
    };

    const classes = clsx(css.root, className);

    return (
      <IconButton
        ref={ref}
        className={classes}
        label={copied ? copiedLabel : label}
        onClick={handleClick}
        {...rest}
      >
        <span className={css.iconWrap} data-copied={copied || undefined}>
          {copied && renderCopiedIcon
            ? renderCopiedIcon()
            : renderIcon
            ? renderIcon()
            : copied
            ? "\u2713"
            : "\u2398"}
        </span>
      </IconButton>
    );
  },
);

CopyButton.displayName = "CopyButton";

CopyButton.propTypes = {
  text: PropTypes.string.isRequired,
  label: PropTypes.string,
  copiedLabel: PropTypes.string,
  renderIcon: PropTypes.func,
  renderCopiedIcon: PropTypes.func,
  className: PropTypes.string,
};

export default CopyButton;
